import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

function Textarea(props) {
    const { label, error, fullWidth, helperText, maxLength, ...other } = props;

    const classForm = clsx("form-item", {
        "form-item--width": fullWidth,
    });

    // const hasError = Boolean(error);
    const hText = error || helperText;

    return (
        <div className={classForm}>
            {label && <label htmlFor={other.name}>{label}</label>}
            <textarea className="input" rows="5" cols="30" {...other} maxLength={maxLength} />
            {hText && <p>{hText}</p>}
            {maxLength && <small className="label">{`${(props.value || "").length} / ${maxLength}`}</small>}
        </div>
    );
}

Textarea.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    label: PropTypes.string,
    error: PropTypes.string,
    helperText: PropTypes.string,
    rows: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxLength: PropTypes.number,
};

Textarea.defaultProps = {
    onChange: undefined,
    label: undefined,
    error: undefined,
    helperText: undefined,
    rows: 10,
    value: "",
    maxLength: undefined,
};

export default Textarea;
